import { FormControl } from '@material-ui/core';
import styled, { css } from 'styled-components';

import type {
  IKakarikoSelectStyleProps,
  IKakarikoSelectRootStyleProps,
} from './types';

export const StyledKakarikoSelectRoot = styled.div<IKakarikoSelectRootStyleProps>`
  ${(props: IKakarikoSelectRootStyleProps & { theme: any }) => {
    return css`
      grid-column: ${['short', 'half'].includes(props.$width || '') &&
      'span 1 !important'};

      .error {
        color: ${props.theme.warningBase};
        color: var(--warning-base);
        flex-basis: 100%;
      }
    `;
  }};
`;

export const StyledKakarikoSelect = styled(
  FormControl,
)<IKakarikoSelectStyleProps>`
  ${(props: { theme: any }) => {
    return css`
      border: 8px solid transparent;
      min-width: 0;
      width: 100%;

      .MuiTextField-root {
        background: var(--white-full);
      }

      .MuiInputBase-root {
        border-radius: 3px 3px 0 0;
      }

      .MuiInput-underline,
      .MuiFilledInput-underline {
        &:hover::before {
          border-bottom: 2px solid var(--primary-light) !important;
        }
        &::before {
          border-bottom: 2px solid var(--default-base);
        }

        &::after {
          border-color: var(--primary-base);
        }

        &:hover {
          border-color: var(--primary-light);
        }

        &.Mui-error {
          &:after {
            border-bottom-color: ${props.theme.warningBase};
            border-bottom-color: var(--warning-base);
          }

          & .MuiSvgIcon-root {
            color: ${props.theme.warningBase};
            color: var(--warning-base);
          }

          + .MuiFormLabel-root {
            color: ${props.theme.warningBase};
            color: var(--warning-base);
          }
        }
      }

      .MuiOutlinedInput-root.Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          border-color: var(--primary-base);
        }
      }

      .MuiFormLabel-root.Mui-focused {
        color: var(--primary-base);
      }
    `;
  }}
`;
